import React from 'react';
import Divider from '../../components/content/Divider';
import SectionTitle from '../../components/content/SectionTitle';
import BlockingModal from '../../components/framework/BlockingModal';
import Button from '../../components/input/Button';
import UtilityService from '../../services/UtilityService';
import WindowService from '../../services/WindowService';

const storeUrl = UtilityService.getBaseUrl(window.location.origin);

const EmptyCartPage: React.FC = () => {
  return (
    <BlockingModal isOpen>
      <div style={{ width: 275 }}>
        <SectionTitle>Your cart is empty</SectionTitle>
        <Divider />
        <Button onClick={(): void => WindowService.navigate(storeUrl)}>
          Continue Shopping
        </Button>
      </div>
    </BlockingModal>
  );
};

export default EmptyCartPage;
